/**
 * Registriert den Service Worker der App (ein Worker im Wurzelbereich, ADR-0027): App-Shell, Benachrichtigungen. Wann
 * ein neuer Worker übernimmt, entscheidet der Lebenszyklus (plattform/lebenszyklus.ts, ADR-0041); er löst die Prüfung
 * beim Sichtbarwerden aus Bericht N11 ab.
 */
export async function serviceWorkerRegistrieren(): Promise<ServiceWorkerRegistration | null> {
  if (!("serviceWorker" in navigator) || import.meta.env.DEV) return null;
  try {
    return await navigator.serviceWorker.register("/sw.js", { scope: "/" });
  } catch {
    return null;
  }
}
